import { FC, MutableRefObject, useContext, useState } from 'react'
import { InternalContext } from '../contexts/InternalContext'
import './Channels.scss'
import { ChannelsSelection } from './ChannelsSelection'
import { getPositionRange } from '../../functions/getPositionRange'
import { useObservableEffect } from '../../hooks/useObservableEffect'
import { Position } from '../../types'
import { useVisiblePositionGetPercent } from '../hooks/useVisiblePositionGetPercent'

interface Props {
  playbackCursorPosition: Position
  mousePositionRef: MutableRefObject<Position>
}

export const ChannelsShiftSelection: FC<Props> = ({ playbackCursorPosition, mousePositionRef }) => {
  const { mousePosition } = useContext(InternalContext)
  const [element, setElement] = useState<HTMLDivElement | null>(null)
  const getPercent = useVisiblePositionGetPercent()

  useObservableEffect(mousePosition, () => {
    if (element) {
      const range = getPositionRange(mousePositionRef.current, playbackCursorPosition)

      const left = getPercent(range[0])
      const width = getPercent(range[1]) - left

      element.style.left = `${left}%`
      element.style.width = `${width}%`
    }
  })

  return (
    <ChannelsSelection range={getPositionRange(mousePositionRef.current, playbackCursorPosition)} ref={setElement} />
  )
}
